import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "calc(100vh - 185px)",
    overflowY: "auto",
    paddingTop: theme.spacing(1),
  },
  viewButtons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: theme.spacing(2),
    flexWrap: "wrap",
    marginBottom: theme.spacing(2),
  },
  headerLeft: {
    display: "flex",
    alignItems: "start",
    flexWrap: "wrap",
    flexDirection: "column",
  },
  revenueSourceBanner: {
    display: "inline-flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    padding: "8px 12px",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: 500,
  },
  revenueSourceXero: {
    backgroundColor: "#e8f5e9 !important",
    color: "#2e7d32 !important",
    fontWeight: 600,
    borderRadius: "50px"
  },
  revenueSourceImperans: {
    backgroundColor: "#FEE2E2 !important",
    color: "#B91C1C !important",
    fontWeight: 600,
    borderRadius: "50px !important",
  },
  addNewRevenue: {
    display: "flex",
    justifyContent: "end",
  },
  addRevenueTitle: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: "#1B2A4A",
  },
}));
